/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneSliderSlide from 'base/components/standalone/Slider/Slide';

export const DynamicStandaloneSliderSlide = StandaloneSliderSlide;
export type DynamicStandaloneSliderSlideProps = PropsFromComponent<typeof StandaloneSliderSlide>;

export const DynamicStandaloneSliderSlideWith = (extras: DynamicStandaloneExtras): typeof StandaloneSliderSlide => {
    return function DynamicStandaloneSliderSlide(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SliderSlide');
        return <StandaloneSliderSlide {...mergeProps({ options: { theme } }, props)} />;
    }
}